import { TasksTodayCtrl } from './tasks.today.controller';
import template from './tasks.today.html';

export const tasksToday: angular.IDirectiveFactory = () => {
  return {
    bindToController: true,
    controller: TasksTodayCtrl,
    controllerAs: 'vm',
    template,
    restrict: 'E',
    scope: {
      tasks: '=',
      onTaskClick: '&',
    },
  };
};
